import { Component, OnInit, Input } from '@angular/core';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { ConstantsModule } from '../../constants/constants.module';
import { UtilsModule } from '../../utils/utils.module';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthloginService } from 'src/app/services/login/authlogin.service';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css']
})
export class EditComponent implements OnInit {
  @Input() singleyear;
  @Input() windowdata;
  yearDropDownList = [];
  attendanceFilter: object = { mom: '', startdate: '',enddate : '' };
  selectedDate: any;
  startDateminDate : any
  setwindowstatus :any
  startDatemaxDate :any;
  endDateminDate;
  endDatemaxDate;
  endDatepicker: any;
  selectedEndDate: any;
  activeSpinner : boolean = false;
  dateformat = {value: 'yyyyMMdd'}
  validation: boolean[] = new Array(5).fill(true);
  // setwindowparams = {assessmentyear : '',sdate : null,edate : null}
  setwindowparams = {assessmentyear : '',month : '',sdate : null,edate : null}

  dist_nodal_officer: string;
  userdetails: any;
  state_nodal_officer: string;
  windowtabledata: {};
  enablesetwindow: boolean;
  showtable: boolean;
  shownodata: boolean;
  tabledata
  admin_officer: string;
  monthlist:{key: string, value:string}[] = [
    { key: '04', value: 'April' },
    { key: '05', value: 'May' },
    { key: '06', value: 'June' },
    { key: '07', value: 'July' },
    { key: '08', value: 'August' },
    { key: '09', value: 'September' },
    { key: '10', value: 'October' },
    { key: '11', value: 'November' },
    { key: '12', value: 'December' },
    { key: '01', value: 'January' },
    { key: '02', value: 'February' },
    { key: '03', value: 'March' },
    ];
  monthMapping = {
      '06': 'June',
       '07':'July',
       '08':'August',
       '09':'September',
      '10': 'October',
       '11':'November',
       '12': 'December',
       '01':'January',
      '02': 'February',
       '03':'March',
       '04': 'April',
       '05':'May',
    };
    monthToKeyMapping = {
       'June':'06',
       'July':'07',
       'August':'08',
       'September':'09',
      'October':'10',
       'November':'11',
       'December':'12',
       'January':'01',
      'February':'02',
       'March':'03',
       'April':'04',
       'May':'05',
    };
  selectedMonth: any;
  constructor(private submitdataservice : SubmitdataService,
    private constants : ConstantsModule,
    private utils  : UtilsModule,
    private toastr : ToastrService,
    public activeModal : NgbActiveModal,
    private logsrv : AuthloginService) { }

   async ngOnInit() {
    this.dist_nodal_officer  = this.constants.USER_TYPES['DISTRICT_NODAL_OFFICER'];
    this.state_nodal_officer = this.constants.USER_TYPES["STATE_NODAL_OFFICER"];
    this.admin_officer =  this.constants.USER_TYPES['ADMIN'];
     await this.getWindowStatusAdmin();
    this.userdetails = this.logsrv.checkloginstatus();
    if(!this.singleyear){
     this.setyeardd();
    }else {
      // console.log("window Data",this.windowdata)
      this.yearDropDownList.push(this.singleyear);
      this.setwindowparams['assessmentyear'] = this.singleyear;

      this.setwindowparams['month']=this.monthToKeyMapping[this.getYearAndMonth( this.setwindowparams['assessmentyear'],1)];
      // if(this.userdetails['roles'][0] == 'STATE_NODAL_OFFICER'){
        // this.setwindowparams['sdate'] =  this.utils.getDateObjectFromModelDate(this.windowdata[this.singleyear]['sdate'].toString());
        this.setwindowparams['sdate'] = this.windowdata[this.singleyear]['sdate'];

        this.setwindowparams['edate'] = this.utils.getDateObjectFromModelDate(this.windowdata[this.singleyear]['edate']);

        // console.log("window params",this.setwindowparams)


      this.startDateminDate = this.utils.getDateObjectFromModelDate(this.windowdata[this.singleyear]['sdate'].toString());
      this.startDatemaxDate = this.utils.getDateObjectFromModelDate(this.windowdata[this.singleyear]['edate'].toString());
  //  }
  }
  }
    async setyeardd(){
    Object.keys(this.windowdata).forEach(year =>{
      if(this.windowdata[year].hasOwnProperty("status")  && year != "2015-2016" && year != "2016-2017" && year != "2017-2018"){
        this.yearDropDownList.push(year);
        
      }
    });
    }

    selectOption(month){
      this.setwindowparams['month'] = month
      }
      
      formatdate(date){
        return this.utils.getDateInFormatFromModelDate(date.toString(),"dd-MM-yyyy")
      }

    getYearAndMonth(year,index){
        let arr=year.split("#");
          arr[1]=this.monthMapping[arr[1]];
          return (arr && (arr.length-1>=index) && arr[index])?arr[index]:"-"
    }

   async  getWindowStatusAdmin(){
    let yearDropDownList;
    this.submitdataservice.getYearsToDisplay(this.submitdataservice.yearsPayload).subscribe(data=>{
      yearDropDownList = data['data'];
    })

      let options = {};
      options["isLocationNeeded"] =  false
      options['pEUUID'] = null;
      options["yearlist"] = this.submitdataservice.getassesmentYear(),
      options["view"] =  this.constants.VIEWS['admin'],
      options["cType"] =  this.constants.LOCATION_CONSTANT['STATE']
      this.setwindowstatus = await this.submitdataservice.getWindowStatus(options);
       
  }
    setDateLImit(year){
      if(this.userdetails['roles'][0] == 'STATE_NODAL_OFFICER'){
        this.startDateminDate = this.utils.getDateObjectFromModelDate(this.setwindowstatus[year]['sdate'].toString());
        this.startDatemaxDate = this.utils.getDateObjectFromModelDate(this.setwindowstatus[year]['edate'].toString());
      }
    }
    changeStartDate(value) {
      this.selectedDate = value;
      this.attendanceFilter['startdate'] = this.sendBackendData(value);
      this.endDatepicker =value;
    }
    sendBackendData(date: any): any {
      let year = date.year;
      let month = date.month;
      let day = date.day;
      if (parseInt(month) < 10) {
        month = "0" + month.toString();
      }
  
      if (day < 10) {
        day = "0" + day.toString();
      }
      return year.toString() + month + day;
    } 
    changeEndDate(value){
    this.selectedEndDate = value;
    this.attendanceFilter['enddate'] = this.sendBackendData(value);
    }  
    submitsetwindowdata(){
        this.activeSpinner = true;
        let  year = this.setwindowparams['assessmentyear'];
        let yr=year.split("#");
        
        let postdata = {};
        postdata['ay'] =  yr[0];
        postdata['subTp']=this.setwindowparams['month'];
        // postdata["subTp"]=this.selectedMonth,
        postdata["sdate"] =  this.attendanceFilter['startdate'],
        postdata["edate"] =  this.attendanceFilter['enddate'],
        postdata["cType"]  =  this.constants.LOCATION_CONSTANT['DISTRICT'];
        postdata["view"] =  this.constants.VIEWS['admin']
        this.submitdataservice.setwindow(postdata).subscribe(data =>{
          if(data.status){
            this.toastr.success("Time window successfully set");
            this.activeModal.close('load')
          } else if(data.statuscode == 420){
            this.logsrv.logoutuserandsessionclear();
          } else {
            this.toastr.error("Error while setting window");
          }
          this.activeSpinner = false;
        });
      }
   
    datepickermodelforstart(value){
      this.setwindowparams['sdate'] = parseInt(this.utils.getDateInFormatFromDateObject(value,"yyyyMMdd"));
        this.endDateminDate = value;
    }
    datepickermodelforend(value){
      this.setwindowparams['edate'] = parseInt(this.utils.getDateInFormatFromDateObject(value,"yyyyMMdd"));
    }
    basicvalidation(){
      this.validation[1] = this.utils.checkfield(this.setwindowparams['assessmentyear']);
      // this.validation[3] = this.utils.checkarrayfield(this.setwindowparams['statearray']);
      this.validation[2] = this.utils.checkfield(this.setwindowparams['sdate']);
      this.validation[3] = this.utils.checkfield(this.setwindowparams['edate']);
      this.validation[4]= this.utils.checkfield(this.setwindowparams['month']);
      return this.validation[1]  && this.validation[2] && this.validation[3] && this.validation[4]
    }
}
